export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-6">关于我们</h2>
        <div className="text-sm md:text-base text-foreground-500 leading-relaxed space-y-4">
          <p>
            女神漫画网诞生于对漫画的热爱 — 我们是一群重度漫画爱好者，深知手机翻页看漫画有多麻烦。
            于是我们打造了<strong className="text-foreground-700">女神漫画下拉式</strong>阅读平台，让所有漫友能用最简单的方式畅享韩漫日漫。
          </p>
          <p>
            平台上线以来，女神漫画下拉式模式凭借<strong className="text-foreground-700">流畅的滚动体验和免费全集策略</strong>，
            迅速积累了海量忠实用户。我们从韩漫恋爱甜文到日漫热血战斗，持续扩充内容库，
            只为实现一个目标：<strong className="text-foreground-700">让每个人都能轻松享受下拉式漫画阅读的乐趣</strong>。
          </p>
          <p>
            未来，女神漫画网将继续优化下拉式阅读技术，拓展更多漫画品类，
            并探索更智能化、个性化的推荐方式。感谢每一位漫友的陪伴与支持。
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-8 mt-8 pt-8 border-t border-background-200/70">
          <div className="text-center">
            <div className="text-2xl font-heading text-accent-500">2000+</div>
            <p className="text-xs text-foreground-500 mt-1">漫画作品</p>
          </div>
          <div className="text-center">
            <div className="text-2xl font-heading text-accent-500">50万+</div>
            <p className="text-xs text-foreground-500 mt-1">日活漫友</p>
          </div>
          <div className="text-center">
            <div className="text-2xl font-heading text-accent-500">3年</div>
            <p className="text-xs text-foreground-500 mt-1">持续运营</p>
          </div>
        </div>
      </div>
    </section>
  );
}